import { Action } from '@ngrx/store';

export enum UsuarioConfigActionTypes {
  USER_CONFIG_NEW = '[USER_CONFIG_NEW] Add usuario config',
  USER_CONFIG_ALL = '[USER_CONFIG_NEW] Get usuario config ALL',
}

export class UsuarioConfigAll implements Action {
  readonly type = UsuarioConfigActionTypes.USER_CONFIG_ALL;
}

export class UsuarioConfigNovo implements Action {
  readonly type = UsuarioConfigActionTypes.USER_CONFIG_NEW;
  constructor(public payload: { userConfig: object }) {}
}

export type UsuarioConfigActions = UsuarioConfigNovo | UsuarioConfigAll;
